<template>
  <div v-if="value">
    <GenericElement
      :properties="properties"
      v-model="localValue[properties.fieldName]"
    />
  </div>
</template>

<script>
import GenericElement from "@/components/form-elements/elements/GenericElement.vue";

const fieldTypeDefaultValue = {
  date: new Date(),
  number: 0,
  daterange: {
    from: new Date(),
    to: new Date()
  },
  timerange: {
    from: "",
    to: ""
  },
  numberrange: {
    from: 0,
    to: 0
  },
  default: ""
};

export default {
  props: {
    properties: {
      type: Object,
      required: true
    },
    value: {
      required: true
    }
  },
  components: {
    GenericElement
  },
  watch: {
    localValue: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      }
    }
  },
  methods: {
    sanitzeModel() {
      if (!this.modelPropertyCheck(this.properties.fieldName)) {
        this.addPropertyToModel(this.properties);
      }
    },
    modelPropertyCheck(fieldName) {
      return (
        this.value.hasOwnProperty(fieldName) &&
        this.value[fieldName] != null &&
        this.value[fieldName] != undefined
      );
    },
    addPropertyToModel(customField) {
      let value =
        customField.defaultValue ??
        fieldTypeDefaultValue[customField.fieldType] ??
        fieldTypeDefaultValue.default;
      this.$set(this.value, customField.fieldName, value);
    }
  },
  created() {
    this.sanitzeModel();
  }
};
</script>

<style lang="scss" scoped></style>
